import { useCallback, useMemo } from 'react';
import { prop } from 'ramda';

import { useUserSelector } from '@core/js/store/hooks';

import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { IPlayerTag } from '@interlayer/js/hooks/user/store/buzz/types';

type TSlotClubPlayerTag = { name: string };

export const useCheckSlotClubOptedInPlayerTags = () => {
    const [
        dTagSlotsClubOptedInPlayerTag = '',
        dTagSlotsClubSignupOptedInPlayerTag = ''
    ] = useDynamicTags([
        DYNAMIC_TAG_NAMES.slotsClubOptedInPlayerTag,
        DYNAMIC_TAG_NAMES.slotsClubSignupOptedInPlayerTag
    ]);

    return useCallback((playerTags: Record<string, IPlayerTag> | null) => {
        if (!playerTags) {
            return [];
        }

        return [
            dTagSlotsClubOptedInPlayerTag,
            dTagSlotsClubSignupOptedInPlayerTag
        ].reduce<TSlotClubPlayerTag[]>((acc, slotPlayerTag) => {
            if (playerTags[slotPlayerTag]) {
                return [...acc, { name: slotPlayerTag }];
            }

            return acc;
        }, []);
    }, [dTagSlotsClubOptedInPlayerTag, dTagSlotsClubSignupOptedInPlayerTag]);
};

export const useSlotClubOptedInPlayerTags = (): TSlotClubPlayerTag[] => {
    const allPlayerTags = useUserSelector(prop('allPlayerTags'));
    const checkSlotClubOptedInPlayerTags = useCheckSlotClubOptedInPlayerTags();

    return useMemo(() => checkSlotClubOptedInPlayerTags(allPlayerTags), [allPlayerTags, checkSlotClubOptedInPlayerTags]);
};
